import React from 'react';
import { Box } from '@mui/material';
import { AU, FUENTE } from '../../styles/tokensAU';

// Hitos en vertical unidos por una línea: [{ titulo, detalle, fecha? }].
const LineaDeTiempo = ({ hitos }) => (
  <Box component="ol" role="list" sx={{ listStyle: 'none', m: 0, p: 0 }}>
    {hitos.map((hito, i) => {
      const ultimo = i === hitos.length - 1;
      return (
        <Box key={`${i}-${hito.titulo}`} component="li" sx={{ display: 'flex', gap: 1.5, pb: ultimo ? 0 : 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Box aria-hidden="true" sx={{ width: 10, height: 10, mt: '7px', borderRadius: '50%', bgcolor: AU.azul, flexShrink: 0 }} />
            {!ultimo && <Box aria-hidden="true" sx={{ flex: 1, width: '2px', mt: 0.5, bgcolor: AU.azul, opacity: 0.35 }} />}
          </Box>
          <Box>
            <Box component="p" sx={{ m: 0, fontFamily: FUENTE, fontSize: 15, fontWeight: 700, color: AU.oscuro }}>
              {hito.titulo}
              {hito.fecha && (
                <Box component="span" sx={{ color: AU.azulHover, fontWeight: 600 }}>{` · ${hito.fecha}`}</Box>
              )}
            </Box>
            <Box component="p" sx={{ m: 0, fontFamily: FUENTE, fontSize: 14, color: AU.oscuro }}>{hito.detalle}</Box>
          </Box>
        </Box>
      );
    })}
  </Box>
);

export default LineaDeTiempo;
